import React from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { CloseCircleOutlined, ReloadOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

interface GlobalErrorMessageProps {
  error?: {
    message: string;
    statusCode?: number;
    details?: string;
  };
  visible: boolean;
  onClose: () => void;
  onRetry?: () => void;
}

const GlobalErrorMessage: React.FC<GlobalErrorMessageProps> = ({
  error,
  visible,
  onClose,
  onRetry,
}) => {
  if (!visible || !error) return null;

  const status: "warning" | "error" = (error.statusCode ?? 0) >= 500 ? "error" : "warning";
  const title = error.statusCode ? `Error (${error.statusCode})` : "Error";

  return (
    <div className="global-error-container">
      <Result
        status={status}
        title={title}
        subTitle={error.message}
        icon={<CloseCircleOutlined style={{ color: '#f5222d' }}/>}
        extra={
          <Space>
            <Button type="primary" onClick={onClose}>
              Dismiss
            </Button>
            {onRetry && (
              <Button icon={<ReloadOutlined />} onClick={onRetry}>
                Try Again
              </Button>
            )}
          </Space>
        }
      >
        {error.details && (
          <div className="error-details">
            <Paragraph>
              <Text strong>Details:</Text>
            </Paragraph>
            <Paragraph>
              <Text code>{error.details}</Text>
            </Paragraph>
          </div>
        )}
      </Result>
    </div>
  );
};

export default GlobalErrorMessage;